import { render, staticRenderFns } from "./HomeConfig.vue?vue&type=template&id=61cf2e5c"
import script from "./HomeConfig.vue?vue&type=script&lang=js"
export * from "./HomeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports